// File: src/components/card/StyledCard.js
// -----------------------------------------------------
import React from 'react';
import { Card } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Styled card component following Material Design 3 guidelines
 * Includes keyboard accessibility for interactive cards
 */
const StyledCard = ({ children, onClick, ...props }) => {
  const handleKeyDown = (event) => {
    if (onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick(event);
    }
  };

  return (
    <Card
      onClick={onClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      elevation={0} // M3 uses flat tonal containers
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        '&:hover': onClick ? {
          transform: 'translateY(-5px) scale(1.01)',
          borderColor: (theme) => theme.palette.primary.main,
          boxShadow: (theme) => theme.palette.mode === 'dark'
            ? '0px 12px 30px rgba(181, 235, 185, 0.2)'
            : '0px 12px 30px rgba(0, 65, 73, 0.08)',
        } : {},
        // Focus rings for keyboard navigation
        '&:focus-visible': {
          outline: (theme) => `3px solid ${theme.palette.primary.main} !important`,
          outlineOffset: '2px !important',
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Card>
  );
};

StyledCard.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  sx: PropTypes.object
};

export default StyledCard;